import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import {SFSchema, SFUISchema} from '@delon/form';

@Component({
  selector: 'app-log-oplog-edit',
  templateUrl: './edit.component.html',
})
export class LogOplogEditComponent implements OnInit {
  record: any = {};
  i: any;
  schema: SFSchema = {
  //   properties: {
    //   id: {
    //     type: 'string',
    //     title: 'æ¥å¿ç¼å·'
    //   },
    //   userId: {
    //     type: 'string',
    //     title: 'ç¨æ·ç¼å·'
    //   },
    //   succeed: {
    //     type: 'string',
    //     title: 'æä½ç»æ'
    //   },
    //   ip: {
    //     type: 'string',
    //     title: 'ip'
    //   },
    //   recordType: {
    //     type: 'string',
    //     title: 'æä½ç±»å'
    //   },
    //   recordId: {
    //     type: 'string',
    //     title: 'id'
    //   },
    //   opType: {
    //     type: 'string',
    //     title: 'æä½ç±»å'
    //   },
    //   msgCode: {
    //     type: 'string',
    //     title: 'msgCode'
    //   },
    //   message: {
    //     type: 'string',
    //     title: 'message'
    //   },
    //   optTime: {
    //     type: 'date',
    //     title: 'æä½æ¶é´'
    //   }
    // },
    // required: ['id', 'userId', 'succeed', 'ip','recordType','recordId','opType','msgCode','message','optTime'],
  };
  ui: SFUISchema = {
    '*': {
      spanLabelFixed: 100,
      grid: { span: 12 },
    },
    $no: {
      widget: 'text'
    },
    $href: {
      widget: 'string',
    },
    $description: {
      widget: 'textarea',
      grid: { span: 24 },
    },
  };

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public http: _HttpClient,
  ) {}

  ngOnInit(): void {
    if (this.record.id > 0)
    this.http.get(`/user/${this.record.id}`).subscribe(res => (this.i = res));
  }

  save(value: any) {
    this.http.post(`/user/${this.record.id}`, value).subscribe(res => {
      this.msgSrv.success('ä¿å­æå');
      this.modal.close(true);
    });
  }

  close() {
    this.modal.destroy();
  }
}
